const flowReducer = (state = {}, action) => {
  switch (action.type) {
    case "FETCH_FLOW_TYPE_META": {
      return {
        ...state,
        flow_type_meta: action.payload,
      };
    }
    case "SET_FLOW_TYPE_META": {
      return {
        ...state,
        flow_type_meta: null,
      };
    }

    case "ADD_FLOW_TO_STEP_REMOTE": {
      return state;
    }
    // case "ADD_FLOW_TO_STEP_LOCAL": {
    //   return state;
    // }

    default:
      return state;
  }
};

export default flowReducer;

// const dbgFn = (state, action) => {
//   console.log("TOTO STATE", state);
//   console.log("TOTO ACTION", action);
// };
